import { axiosBasic } from "../config/axios-common";

const postInsertOrUpdateBusiness = async (data: any, professionalId: string) => {

  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      }
    }

    const response = await axiosBasic.post(`/sam/v1/businessData/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);
    
    return await response;
    
  } catch (e: any) {
    throw e;
  }
};

const exportedObject = {
  postInsertOrUpdateBusiness
};


export default exportedObject
